const multiSelectOptions = {
  ransackParams: (filters, filterKey, filterValue) => (
    { [`q[${filters[filterKey].ransackLabel}]`]: filterValue }
  ),
  setupFilters: defaultValue => defaultValue || [],
  handleFilterChange: (event, allFilters, nameOfFilter) => {
    const changedInput = event.currentTarget.value;
    const filtersForChangedInput = allFilters[nameOfFilter];
    let updatedFilter;

    if (filtersForChangedInput.includes(changedInput)) {
      updatedFilter = filtersForChangedInput.filter(id => id !== changedInput);
    } else {
      updatedFilter = [...filtersForChangedInput, changedInput];
    }

    return { ...allFilters, [nameOfFilter]: updatedFilter };
  },
  removeFilter: ({ allFilters, nameOfFilter, filterKey }) => {
    const updatedFilter = allFilters[nameOfFilter].filter(id => id !== filterKey);
    return { ...allFilters, [nameOfFilter]: updatedFilter };
  }
};

const accordionOption = {
  ...multiSelectOptions,
  handleFilterChange: (event, allFilters, nameOfFilter, filterKey, childObject) => {
    if (childObject) {
      const changedInput = event.currentTarget.value;
      const filtersForChangedInput = allFilters[nameOfFilter];
      let updatedFilter, childFilterValues;

      if (filtersForChangedInput.includes(changedInput)) {
        updatedFilter = filtersForChangedInput.filter(id => id !== changedInput);
        const removeParentValues = childObject && childObject.values.map(option => option.value);
        childFilterValues = childObject && allFilters[childObject.label]
          .filter(option => !removeParentValues.includes(option));
      } else {
        updatedFilter = [...filtersForChangedInput, changedInput];
        const additionalChildFilterValues = childObject && childObject.values.map(option => option.value);
        childFilterValues = [...allFilters[childObject.label], ...additionalChildFilterValues];
      }

      return {
        ...allFilters,
        [nameOfFilter]: updatedFilter,
        [childObject.label]: childFilterValues
      };
    } else {
      return multiSelectOptions.handleFilterChange(event, allFilters, nameOfFilter);
    }
  }
};

// TODO: Make a better version of this for search
const searchOption = {
  ...multiSelectOptions,
  setupFilters: () => '',
};

const selectOption = {
  ransackParams: (filters, filterKey, filterValue) => (
    { [`q[${filters[filterKey].ransackLabel}]`]: filterValue }
  ),
  setupFilters: defaultValue => defaultValue || 'any',
  handleFilterChange: (event, allFilters, nameOfFilter) => {
    return { ...allFilters, [nameOfFilter]: event.currentTarget.value };
  }
};

const sharedMinMaxOptions = {
  ransackParams: (filters, filterKey, filterValue) => {
    const params = {};

    if (filterValue.min !== '') {
      params[`q[${filters[filterKey].ransackLabel}_gteq]`] = filterValue.min;
    }
    if (filterValue.max !== '') {
      params[`q[${filters[filterKey].ransackLabel}_lteq]`] = filterValue.max;
    }

    return params;
  },
  setupFilters: () => ({ min: '', max: '' }),
  handleFilterChange: (event, allFilters, nameOfFilter, filterKey) => {
    const filtersForChangedInput = allFilters[nameOfFilter];
    return {
      ...allFilters,
      [nameOfFilter]: { ...filtersForChangedInput, [filterKey]: event.currentTarget.value }
    };
  },
  removeFilter: ({ allFilters, nameOfFilter, filterKey }) => (
    { ...allFilters, [nameOfFilter]: { ...allFilters[nameOfFilter], [filterKey]: '' } }
  )
};

// A tick box of its own, where a child filter's hangs off its parent filter. Unticked sends nothing.
const checkboxOptions = {
  ransackParams: (filters, filterKey, filterValue) => (
    filterValue ? { [`q[${filters[filterKey].ransackLabel}]`]: true } : {}
  ),
  setupFilters: defaultValue => defaultValue || false
};

const childFilterOptions = {
  setupFilters: () => false,
  removeFilter: ({ allFilters, filterData }) => (
    { ...allFilters, [filterData.childFilter.key]: false }
  ),
  ransackParams: (filters, filterKey, filterValue) => (
    { [`q[${filters[filterKey].childFilter.ransackLabel}]`]: filterValue }
  ),
};

export const savedReportsUrl = '/saved_reports';
export const CHILD_FILTER_TYPE = 'child';

// Mirrors Reports::BasePresenter#filter_by_status: blank or both statuses selected shows
// everything, otherwise only options matching the selected status.
export function optionsForStatus(options, statuses) {
  const hasActive = statuses.includes('active');
  const hasDisabled = statuses.includes('disabled');
  if (statuses.length === 0 || (hasActive && hasDisabled)) return options;

  return options.filter(option => Boolean(option.disabled) === hasDisabled);
}

// Builds a deriveFilterValues for BaseReport that status-filters a single filterValues key.
export function deriveStatusFilteredValues(key) {
  return (filterValues, selectedFilters) => ({
    ...filterValues,
    [key]: { options: optionsForStatus(filterValues?.[key]?.options ?? [], selectedFilters?.status ?? []) }
  });
}

export const filterTypeOptions = {
  'accordion': accordionOption,
  'checkbox': checkboxOptions,
  'search': searchOption,
  'multiselect': multiSelectOptions,
  'dropdown': multiSelectOptions,
  'range': sharedMinMaxOptions,
  'date': sharedMinMaxOptions,
  'select': selectOption,
  [CHILD_FILTER_TYPE]: childFilterOptions
};
